module.exports = "\r\n\r\n<app-product-list [featured]=\"true\" [query]=\"\"></app-product-list>\r\n    "